import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import ShellNavigation from './ShellNavigation';

let buildVersion: { commitSha: string; version: string } | null = null;
try {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  buildVersion = require('../generated/buildVersion').buildVersion;
} catch {
  // Not yet generated
}

export default function PublicLayout() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <ShellNavigation />
      <Box sx={{ flex: 1 }}>
        <Outlet />
      </Box>
      {buildVersion && (
        <Box component="footer" sx={{ py: 0.5, px: 2, textAlign: 'right' }}>
          <Typography
            variant="caption"
            color="text.disabled"
            sx={{
              cursor: 'pointer',
              fontFamily: 'monospace',
              '&:hover': { color: 'text.secondary' },
            }}
            onClick={() => navigate('/app/debug')}
          >
            v{buildVersion!.version} ({buildVersion!.commitSha})
          </Typography>
        </Box>
      )}
    </Box>
  );
}
